export enum GridViewStatusChipEvent {
  STATUS_CLICK = 'statusClick',
}
